/**
 * Restart – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Restart playback. */
export default function RestartIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${(height || 34) * Screen.widthRatio}`}
      width={`${(width || 30) * Screen.widthRatio}`}
      viewBox={'0 0 32 36'}
    >
      <path
        d='M30.1102 34.8168C28.9448 35.5752 27.3783 35.719 26.001 34.8965L25.9992 34.8955L2.87463 21.0552C1.5917 20.2876 1.02705 18.9408 1.02705 17.7262C1.02705 16.5117 1.59128 15.1651 2.87421 14.3975L25.9992 0.556958L26.001 0.555897C27.3783 -0.266532 28.9448 -0.122806 30.1102 0.635681C31.2583 1.38287 32 2.69901 32 4.20009L32 31.2523C32 32.7534 31.2583 34.0696 30.1102 34.8168ZM27.8918 31.2404L27.8918 4.21204L5.31199 17.7262L27.8918 31.2404Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M0 2.65902C0 1.52457 1.22621 0.604919 2.73881 0.604919C4.25141 0.604919 5.47761 1.52457 5.47761 2.65902V32.7859C5.47761 33.9204 4.25141 34.84 2.73881 34.84C1.22621 34.84 0 33.9204 0 32.7859V2.65902Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
